import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { MockServerService } from '../mock-server.service';
import { Router } from '@angular/router';


export interface SelectOption {
  value: string;
  label: string;
  selected?: boolean; // Optional property to track selection state
}
@Component({
  selector: 'app-admin-widget',
  templateUrl: './admin-widget.component.html',
  styleUrls: ['./admin-widget.component.scss'],
})

export class AdminWidgetComponent implements OnInit {
  @Input() customClass = '';
  endpoints: any[] = [];
  endpointSearchText: string = '';
  savedSettings: any[] = [];
  constructor(
    private mockServerService: MockServerService,
    private router: Router
  ) { }

  ngOnInit() {
    const savedMockServerEnabled = localStorage.getItem('mockServerEnabled');
    if (savedMockServerEnabled !== null) {
      this.mockServerEnabled = JSON.parse(savedMockServerEnabled);
      if (this.mockServerEnabled) {
        this.loadEndpoints();
      }
    }
    
    // Initialize secret code validation status from service
    this.isSecretCodeValidated = this.mockServerService.getSecretCodeValidationStatus();
    
    // Subscribe to secret code validation status changes
    this.mockServerService.secretCodeValidated$.subscribe((status) => {
      this.isSecretCodeValidated = status;
    });
    
    this.loadSavedSettings();

    // Subscribe to mock server status changes
    this.mockServerService.mockServerStatus$.subscribe((status) => {
      this.mockServerEnabled = status;
    });
  }

  isOpen = false;

  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }

  mockServerEnabled = false;
  isSecretCodeValidated = false;
  onMockServerChange(event: Event): void {
  //  localStorage.setItem('mockServerEnabled', JSON.stringify(this.mockServerEnabled));
    this.mockServerService.setMockServerStatus(this.mockServerEnabled);

    if (this.mockServerEnabled === true) {
      this.loadEndpoints();
    }
  }

  private loadEndpoints(): void {
    this.mockServerService.getUniqueEndpoints().subscribe((apiEndpoints: any[]) => {
      this.endpoints = apiEndpoints.map((item) => {
        return {
          value: `${item.req_method} ${item.req_url}`,
        }
      });
    });
  }

  selectedEndPoint: any = {};

  // Endpoints data

  testCases: { value: string; label: string }[] = [];

  onEndpointSelectionChange(event: MatSelectChange): void {
    const [req_method, ...urlParts] = event.value.split(' ');
    const req_url = urlParts.join(' ');
    this.mockServerService.getCasesForEndpoint(req_url, req_method)
      .subscribe((cases: any[]) => {
        this.testCases = cases.map((c) => ({
          value: c.cases,
          label: c.cases
        }));
        this.selectedCase = '';
      });
  }

  // Test cases 
  selectedCase: string = ''; // Default selected case

  onCaseSelectionChange(event: any): void {
    console.log('Selected test case:', event.value);
  }

  private loadSavedSettings(): void {
    const savedSettings = localStorage.getItem('adminWidgetSettings');
    if (savedSettings) {
      try {
        const parsed = JSON.parse(savedSettings);
        this.savedSettings = Array.isArray(parsed) ? parsed : [parsed];
      } catch (error) {
        console.error('Error parsing saved settings:', error);
        this.savedSettings = [];
      }
    } else {
      this.savedSettings = [];
    }
  }

  saveSettings() {
    const newEndpoint = this.selectedEndPoint;
    const newCase = this.selectedCase;
    const currentTime = new Date().toISOString();

    // Check if endpoint already exists
    const existingSettingIndex = this.savedSettings.findIndex(
      (setting) => setting.endpoint === newEndpoint
    );

    if (existingSettingIndex !== -1) {
      this.savedSettings[existingSettingIndex].case = newCase;
      this.savedSettings[existingSettingIndex].updatedTime = currentTime;
    } else {
      // Add new setting if endpoint is not found
      this.savedSettings.push({
        endpoint: newEndpoint,
        case: newCase,
        updatedTime: currentTime,
      });
    }

    // Save the updated array back to localStorage
    localStorage.setItem('adminWidgetSettings', JSON.stringify(this.savedSettings));

    // Clear the form after saving
    this.selectedEndPoint = {};
    this.selectedCase = '';
  }

  filteredEndpoints() {
    if (!this.endpointSearchText || this.endpointSearchText.trim() === '') {
      return this.endpoints;
    }
    const search = this.endpointSearchText.toLowerCase();
    return this.endpoints.filter(item => item.value.toLowerCase().includes(search));
  }


  openMockServerSettings() {
    // Logic to open mock server settings
    console.log('Opening Mock Server settings...');
    // You can implement the logic to navigate to the settings page or open a dialog here
    // this.router.navigate(['/mock-server-settings']);
    const urlMockSettings = this.router.serializeUrl(
      this.router.createUrlTree(['/mock-server-settings'])
    );
    window.open(urlMockSettings, '_blank');
  }

  secretCode: string = '';
  validateSecretCode() {

    this.mockServerService.validateMockServerSecretCode(this.secretCode)
      .subscribe({
        next: (response) => {
          console.log('Secret code validation response:', response);

          if (response.secret_code_matched === true) {
            console.log('Secret code validated successfully');
            this.mockServerService.setSecretCodeValidationStatus(true);
            this.mockServerService.setMockServerStatus(true);
            this.mockServerService.setShowAdminWidget(true);
            this.loadEndpoints();
            this.secretCode = '';
          } else {
            console.log('Secret code validation failed');
            this.mockServerService.setSecretCodeValidationStatus(false);
            this.mockServerService.setMockServerStatus(false);
            alert('Invalid secret code. Please try again.');
            this.secretCode = '';
          }
        },
        error: (error) => {
          console.log('API error:', error);
          this.mockServerService.setSecretCodeValidationStatus(false);
          this.mockServerService.setMockServerStatus(false);
          alert('Error validating secret code. Please try again.');
          this.secretCode = '';
        }
      });
  }
}
